import React from "react";
import { useQuery } from "react-query";
import { axiosInstance } from "../../../utils/axios"; // Assuming axiosInstance is configured with the base URL and headers
import AdminSidebar from "../../../components/AdminSidebar";
import SoldStock from "../Devices/SoldStock";

const SoldStockReport = () => {
  return (
    <AdminSidebar>
      <SoldStock />
    </AdminSidebar>
  );
};

export default SoldStockReport;
